export function buildSseUrl(baseURL: string): string {
    const baseUrl = String(baseURL ?? '').replace(/\/api\/?$/, '')
    return `${baseUrl}/sse`
}
